import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Switch, Route, useHistory, useLocation } from 'react-router-dom';
import { supportedLngs } from './i18n';
import { i18nCreator, ThemeProvider } from '@sunday/component';
import Home from './pages/home';
import About from './pages/about';
import Health from './pages/health';
import Contact from './pages/contact';
import Partner from './pages/partner';

const baseRouteUrl = `/:locale(${supportedLngs.join('|')})?`;

const App = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const currentPath = location.pathname + location.search;

  // replace to deteched language
  useEffect(() => {
    const detectedLng = i18n.language;
    const hash = window.location.hash;
    if (!currentPath.match(new RegExp(`^/(${supportedLngs.join('|')})?/`))) {
      history.replace(`/${detectedLng}${currentPath}${hash}`);
      return;
    }

    // If a hash exists, trigger scroll after language update
    if (hash) {
      // Wait for the next render cycle to make sure the DOM is updated
      setTimeout(() => {
        const targetElement = document.querySelector(hash);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 0);
    }
  }, [i18n.language, currentPath, history]);

  const [init, setInit] = useState(false);

  if (!init) {
    const suncomI18n = i18nCreator(i18n.language);
    i18n.on("languageChanged", (lng) => {
      suncomI18n.changeLanguage(lng);
    });
    setInit(true);
  }

  return (
    <ThemeProvider theme='ice-cream'>
      <Switch>
        <Route path={baseRouteUrl + '/about'}>
          <About />
        </Route>
        <Route path={baseRouteUrl + '/health'}>
          <Health />
        </Route>
        <Route path={baseRouteUrl + '/partners'}>
          <Partner />
        </Route>
        <Route path={baseRouteUrl + '/contact'}>
          <Contact />
        </Route>
        <Route path={baseRouteUrl}>
          <Home />
        </Route>
      </Switch>
    </ThemeProvider>
  );
};

export default App;
